module.exports = __webpack_public_path__ + "zespol_05.jpg?e9d537e8f454e9462667b9a2f076975f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_05.jpg
// module id = 150
// module chunks = 0